import React, { useState } from 'react';
import { ClipboardList, Search } from 'lucide-react';
import { api } from '../api';
import { useApp } from '../contexts/AppContext';

const STATUS_COLORS = {
  pending:    { bg: '#fef9c3', color: '#854d0e' },
  confirmed:  { bg: '#dbeafe', color: '#1e40af' },
  processing: { bg: '#ede9fe', color: '#5b21b6' },
  shipped:    { bg: '#cffafe', color: '#164e63' },
  delivered:  { bg: '#dcfce7', color: '#166534' },
  cancelled:  { bg: '#fee2e2', color: '#991b1b' },
};

export default function MyOrdersPage() {
  const { t, lang, formatPrice } = useApp();
  const [phone, setPhone] = useState('');
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const handleSearch = async () => {
    if (!phone.trim()) return;
    setLoading(true);
    try {
      const res = await api.getOrdersByPhone(phone.trim());
      setOrders(res.data.orders || []);
    } catch {
      setOrders([]);
    }
    setLoading(false);
    setSearched(true);
  };

  return (
    <div className="page-pb page-center" style={{ padding: '16px 16px 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <ClipboardList size={24} color="#8B1A1A" />
        <span style={{ fontSize: 20, fontWeight: 800, color: '#111' }}>{t.myOrders}</span>
      </div>

      {/* Phone search */}
      <div style={{ background: '#fff', borderRadius: 16, padding: 16, marginBottom: 20, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ fontSize: 14, color: '#6b7280', marginBottom: 12 }}>{t.enterPhoneToTrack}</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            type="tel"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSearch()}
            placeholder="+965 XXXXXXXX"
            style={{
              flex: 1, padding: '11px 14px', borderRadius: 12, fontSize: 14,
              border: '1.5px solid #e5e7eb', outline: 'none', fontFamily: 'inherit', direction: 'ltr'
            }}
          />
          <button onClick={handleSearch} disabled={loading} style={{
            background: '#8B1A1A', color: '#fff', border: 'none',
            borderRadius: 12, padding: '0 18px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 600
          }}>
            <Search size={16} />{lang === 'ar' ? 'بحث' : 'Search'}
          </button>
        </div>
      </div>

      {/* Results */}
      {loading && (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ width: 36, height: 36, border: '3px solid #8B1A1A', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto' }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      )}

      {!loading && searched && orders?.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 20px', color: '#9ca3af' }}>
          <ClipboardList size={48} style={{ marginBottom: 12, opacity: 0.4 }} />
          <div style={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>{t.noOrders}</div>
        </div>
      )}

      {!loading && orders && orders.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {orders.map(order => {
            const sc = STATUS_COLORS[order.status] || STATUS_COLORS.pending;
            const statusLabel = t.orderStatus[order.status] || order.status;
            return (
              <div key={order.id} style={{ background: '#fff', borderRadius: 16, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <div style={{ fontSize: 12, color: '#9ca3af' }}>#{order.id.substring(0, 8).toUpperCase()}</div>
                  <div style={{ background: sc.bg, color: sc.color, borderRadius: 20, padding: '3px 10px', fontSize: 12, fontWeight: 700 }}>
                    {statusLabel}
                  </div>
                </div>
                {order.sheep?.map(s => (
                  <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '3px 0', borderBottom: '1px solid #f5f5f5' }}>
                    <span>{lang === 'ar' ? s.breed_ar : s.breed_en || s.given_name}</span>
                    <span style={{ fontWeight: 600 }}>{formatPrice(s.online_price)}</span>
                  </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 15, marginTop: 10 }}>
                  <span>{t.total}</span>
                  <span style={{ color: '#166534' }}>{formatPrice(order.total_price_kwd)}</span>
                </div>
                <div style={{ fontSize: 11, color: '#d1d5db', marginTop: 6 }}>
                  {new Date(order.created_at).toLocaleDateString(lang === 'ar' ? 'ar-KW' : 'en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
